export const environment = {
  production: false,
  token: "c12eb8d0ec124a81871330fa356e7e09",
  clientId: "e4234522f0544dd2913d41c68ffd6956",
  clientSecret: "95a1eefb3730481d9ca4974c67ff139e",
  redirectUrl: 'https://munipenaflor-develop.solnet.cl',
  claveUnicaUrl:'https://lnxaz05.solnet.cl:3020',
  backUrl:'https://nidx.solnet.cl:4516'
};
